import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';

import { setModalState } from 'store/entities/app';
import useTotalPrice from 'hooks/useTotalPrice';

import Price from 'components/Price';
import Disclaimer from 'components/Price/Disclaimer';

const StickyAside = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { builderData } = useSelector(state => state.data);
  const totalPrice = useTotalPrice();

  const handleModal = (modal, type) => {
    const conclusion = `/${i18n.language}/conclusion`;
    if (location.pathname !== conclusion) navigate(conclusion);
    dispatch(setModalState({ modal, newState: true, type }))
  };

  return (
    <aside className="c-aside">
      <div className="c-aside__head">
        <p className="c-aside__title">
          {t('your_configured_car', { model: builderData.model?.name })}
        </p>
        <h6 className="c-aside__price">
          <Price price={totalPrice} /> {t('leasing_per_month')}
          <Disclaimer />
        </h6>
      </div>
      <p className="c-aside__btnline">
        <Button
          variant="primary"
          onClick={() => handleModal('offerModal', 'offer')}
        >
          {t('ask_offer_button')}
        </Button>
        <Button
          variant="light"
          onClick={() => handleModal('offerModal', 'testdrive')}
        >
          {t('book_test_button')}
        </Button>
        {false && <Button
          variant="light"
          onClick={() => dispatch(setModalState({modal: 'pdfModal', newState: true}))}
        >
          {t('pdf_button')}
        </Button>}
      </p>
    </aside>
  );
};

export default StickyAside;
